import { render } from "./BlogArticle.vue?vue&type=template&id=4cf983a8&scoped=true&bindings={\"isLoaded\":\"setup\",\"article\":\"setup\",\"ArticleDate\":\"setup\"}"
import script from "./BlogArticle.vue?vue&type=script&lang=js"
export * from "./BlogArticle.vue?vue&type=script&lang=js"

import "./BlogArticle.vue?vue&type=style&index=0&id=4cf983a8&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4cf983a8"

export default script